import { combineReducers } from 'redux';
import { reducer as activeCampaignReducer } from './campaign-builder/store/redux-slice';
import { bannerReducer } from './banners/store/redux-slice';
export var engageV2Reducer = combineReducers({
    activeCampaign: activeCampaignReducer,
    banners: bannerReducer,
});
